import { useState } from 'react';
import { useLocation, useNavigate, useNavigationType } from 'react-router-dom';
import { advanceAccountRoute, initialAccountRoute } from './accountRouteState';
import AccountWorkspaceDialog from './AccountWorkspaceDialog';

export default function AccountRouteFrame({ children, renderAccount }) {
  const location = useLocation();
  const navigationType = useNavigationType();
  const navigate = useNavigate();
  const [route, setRoute] = useState(() => initialAccountRoute(location));
  if (route.location !== location) {
    setRoute(advanceAccountRoute(route, location, navigationType, !!localStorage.getItem('token')));
  }
  const open = !!route.background;
  const close = () => {
    if (route.depth > 0) navigate(-route.depth);
    else navigate(route.background, { replace: true });
    window.dispatchEvent(new Event('credits-updated'));
  };

  return <>
    <div className="account-workspace-background" inert={open ? true : undefined} aria-hidden={open ? true : undefined}>
      {children(route.background || location)}
    </div>
    {open && <AccountWorkspaceDialog onClose={close} onNavigate={to => navigate(to, { replace: true })}>
      {renderAccount(location)}
    </AccountWorkspaceDialog>}
  </>;
}
